export enum AreaProcesso {
    JEC = 3,
    Civel = 2,
    Trabalhista = 1
}